export default (state = {}, action) => {
  switch (action.type) {
    case 'GET_FEATURED_MANUFACTURER':
      return { ...state, manufacturers: action.manufacturers };
    default:
      return state;
  }
};
